import { render, staticRenderFns } from "./LayoutDefault.vue?vue&type=template&id=c79f6168&scoped=true&"
import script from "./LayoutDefault.vue?vue&type=script&lang=js&"
export * from "./LayoutDefault.vue?vue&type=script&lang=js&"
import style0 from "./LayoutDefault.vue?vue&type=style&index=0&id=c79f6168&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c79f6168",
  null
  
)

export default component.exports